<template>
  <div class="heating">
    <div class="heatingCharge" :style="{height: screenHeight}">
      <div class="select" style="height: 100px">
        <el-row class="card-num">
          <el-col :span="5" style="margin-left: 20px; margin-top: 5px"></el-col>
          <el-col :span="16">
            <el-select v-model="yearValue" size="mini" @change="getYearTitle" style="width: 175px;">
              <el-option
                v-for="(item, index) in year"
                :key="item.id"
                :label="item.title+'年度'"
                :value="index"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="card-num">
          <el-col :span="5" style="margin-left: 20px; margin-top: 5px"> 供暖卡号</el-col>
          <el-col :span="16">
            <!--<el-input v-model="cardNumber" size="small" placeholder="反倒是" style="width: 175px"></el-input>-->
            <input class="zw_input" v-model="cardNumber" type="text" >
          </el-col>
        </el-row>
      </div>
      <h4 style="margin:20px 20px 10px 20px">历史缴费记录</h4>
      <div class="history" style="height: 75%" v-if="listTF"> <!--68%-->
        <div class="history-list" v-for=" (item, index) in historyList" @click="getCardNum(index)">
          <el-row>
            <el-col :span="3"><img src="../assets/history.png"/></el-col>
            <el-col :span="9" v-if="item.ClientMstCode.length>12"><span>{{item.ClientMstCode.substr(0,4) + "****" + item.ClientMstCode.substr(-4)}}</span>
            </el-col>
            <el-col :span="9" v-else><span>{{item.ClientMstCode}}</span></el-col>
            <el-col :span="5" :push="2"><p class="houseName">{{item.HousingEstateName}}</p></el-col>
          </el-row>
        </div>
      </div>
      <div v-else class="none">
        <img class="wushuju" src="../assets/wushuju.png" width="120" height="80"/><br/>
        无缴费记录
      </div>
    </div>
    <div class="but" style="height: 80px">
      <div class="agree">
        <nut-checkbox
          v-model="agree"
          :animation="false"
          size="small">
        </nut-checkbox>
        <span class="agreement" @click="dialogTableVisible = true">同意缴费服务协议</span>
      </div>
      <div style="margin-top: 20px;">
        <el-button style="width: 70%;" type="success" size="small" :disabled="!agree" @click="selectCharge">缴费查询
        </el-button>
      </div>
    </div>
    <el-dialog title="缴费服务协议" :visible.sync="dialogTableVisible">
      <span style="margin-left: 5%">1.同意企业服务免责协议同意企业服务免责协议同意企业服务免责协议同意企业服务免责协议同意企业服务免责协议同意企业服务免责协议同意企业服务免责协议同意企业服务免责协议同意企业服务免责协议</span><br/>
      <span style="margin-left: 5%">2.同意企业服务免责协议</span><br/>
      <span style="margin-left: 5%">3.同意企业服务免责协议</span><br/>
      <span style="margin-left: 5%">1.同意企业服务免责协议</span><br/>
      <span style="margin-left: 5%">2.同意企业服务免责协议</span><br/>
      <span style="margin-left: 5%">3.同意企业服务免责协议</span><br/>
      <span style="margin-left: 5%">1.同意企业服务免责协议</span><br/>
      <span style="margin-left: 5%">2.同意企业服务免责协议</span><br/>
      <span style="margin-left: 5%">3.同意企业服务免责协议</span><br/>
      <span style="margin-left: 5%">1.同意企业服务免责协议</span><br/>
      <span style="margin-left: 5%">2.同意企业服务免责协议</span><br/>
      <span style="margin-left: 5%">3.同意企业服务免责协议</span><br/>
      <span style="margin-left: 5%">1.同意企业服务免责协议</span><br/>
      <span style="margin-left: 5%">2.同意企业服务免责协议</span><br/>
      <span style="margin-left: 5%">3.同意企业服务免责协议</span><br/>
      <span style="margin-left: 5%">1.同意企业服务免责协议</span><br/>
      <span style="margin-left: 5%">2.同意企业服务免责协议</span><br/>
      <span style="margin-left: 5%">3.同意企业服务免责协议</span><br/>
    </el-dialog>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Vue from 'vue'

  Vue.component(Toast.name, Toast)
  export default {
    name: "heatingCharge",
    data() {
      return {
        userID: 2,
        // userID: this.$store.getters.getUserInfo.userID,
        openID: "o5vFewIMieT8e-ScGJBzmXVfmxNA",
        // openID: this.$store.getters.getUserInfo.openID,
        yearValue: "无数据",
        yearTitle: "",
        year: [],
        cardNumber: "",
        historyList: [],
        agree: false,
        listTF: false,
        screenHeight: window.innerHeight - 90 + "px",
        dialogTableVisible: false,
        oldYear: false, // 判断跳到详情页是否是本年度
      }
    },
    methods: {
      getHeatingData() {
        let params = {
          userID: this.userID,
          openID: this.openID,
        };
        this.$http.getHeatingData(params).then(res => {
          if (res.state === 1) {
            this.yearValue = 0;
            this.year = res.data.yearList;
            if (res.data.dataList.length > 0) {
              this.historyList = res.data.dataList;
              this.listTF = true;
            }
            if (res.data.yearList.length > 0) {
              this.getYearTitle(0)
            }
          } else {
            Toast({
              message: res.msg,
              duration: 2000
            });
          }
        })
      },

      getCardNum(index) {
        this.cardNumber = this.historyList[index].ClientMstCode
      },

      /**
       * 跳转到缴费详情页面前判断
       */
      selectCharge() {
        let text = /[^\w\.\/]/ig;//是否有中文字符
        let ee = /^[A-Za-z0-9]+$/;//只能输入英文字符和数字
        if (this.cardNumber === "") {
          Toast({
            message: '请选择或输入供暖卡号',
            duration: 2000
          });
        } else if (!ee.test(this.cardNumber)) {
          Toast({
            message: '请输入正确的卡号',
            duration: 2000
          });
        } else if (this.cardNumber.length > 20) {
          Toast({
            message: '请输入20位卡号',
            duration: 2000
          })
        } else {
          this.getCharge();
        }
      },
      /**
       * 判断卡号是否正确和当前卡号是否有缴费记录
       */
      getCharge() {
        let params = {
          yearData: this.yearTitle,
          clientCode: this.cardNumber
        };
        this.$http.getPayment(params).then(res => {
          if (res.state !== 1) {
            Toast({
              message: "卡号错误或该卡号无此年度缴费！",
              duration: 2000
            })
          } else {
            this.$router.push({
              path: '/charge-detail',
              query: {yearTitle: this.yearTitle, butState: true, cardNum: this.cardNumber, oldYear: this.oldYear}
            });
          }
        })
      },

      getYearTitle(index) {
        this.yearTitle = this.year[index].title;
        if (index > 0) {
          this.oldYear = true;
        }
      },

    },

    beforeRouteLeave(to, from, next) {
      let toName = to.name
      if (toName === "updatePhone" || toName === "check") {
        localStorage.clear()
        window.WeixinJSBridge.call('closeWindow')
      } else {
        next()
      }
    },

    mounted() {
      this.getHeatingData();
    }
  }
</script>

<style scoped>
  .heatingCharge {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
  }

  .select {
    width: 100%;
    margin-top: 10px;
    border-bottom: 1px solid #F2F6FC;
  }

  .select h3 {
    margin: 5px 30px;
  }

  .card-num {
    margin-top: 20px;
  }

  .history {
    overflow-x: hidden;
    overflow-y: scroll;
  }

  .history-list {
    margin: 0px 20px 20px 20px;
    height: 30px;
    border-bottom: 1px solid #E4E7ED;
    font-size: 14px;
  }

  .history-list img {
    width: 20px;
    height: 20px;
    /*margin-top: 10px;*/
  }

  .agree {
    width: 160px;
    margin-left: 55px;
  }

  .agreement {
    font-size: 15px;
    color: #F56C6C;
    margin-top: 5px;
    margin-left: 5px;
  }

  .but {
    position: fixed;
    bottom: 0px;
    width: 100%;
    padding-top: 5px;
    padding-bottom: 5px;
    text-align: center;
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.2);
    background-color: #fff;
  }

  .houseName {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 105px;
  }

  .none {
    text-align: center;
    color: gainsboro;
    margin-top: 30%;
  }

  .heating >>> .el-dialog {
    border: 0px;
    border-style: solid;
    border-radius: 2%;
    position: absolute;
    top: -5%;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 90%;
    height: 80%;

  }

  .heating >>> .el-dialog__body {
    line-height: 40px;
    overflow-y: scroll;
    height: 85%;
    padding: 5%;
  }

  .heating >>> .el-dialog__header {
    height: 20px;
    text-align: center;
  }

  .heating >>> .el-dialog__title {
    position: relative;
    top: -5px;
    font-size: 15px;
  }

  .zw_input {
    width:165px;
    height:100%;
    padding: 5px;
    border: 1px solid #DCDFE6; /*#DCDFE6*/
    border-radius: 4px;
    -webkit-appearance: none;
    outline-color: #409EFF;
  }
</style>
<style>
  .el-message-box {
    width: 80%;
    margin-top: -10%;
  }

  .nut-checkbox {
    margin: 0px;
  }

  .nut-checkbox input:checked {
    box-shadow: 0px 0px;
    background-color: #409eff;
    border-color: #409eff;
  }

  .el-button--success.is-disabled, .el-button--success.is-disabled:active, .el-button--success.is-disabled:focus, .el-button--success.is-disabled:hover {
    color: #FFF;
    background-color: #E0F3D8;
    border-color: #E0F3D8;
  }
</style>



// WEBPACK FOOTER //
// src/pages/heatingCharge.vue